<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="请输入培训名称" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="id"
        label="ID"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        label="培训名称"
        >
      </el-table-column>
      <el-table-column
        prop="periodnum"
        label="培训期号">
      </el-table-column>
      <el-table-column
        prop="fee"
        label="费用">
      </el-table-column>
      <el-table-column
        label="已报人数">
        <template slot-scope="scope">
           <span class="blue" @click="showMemberlist(scope.row.periodnum,scope.row.name)">{{scope.row.bmnums}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="状态">
         <template slot-scope="scope">
             <el-tag type="success" v-if="scope.row.status==1 && scope.row.bmstatus==2">上线中</el-tag>
             <el-tag type="info" v-else>
                 <span v-if="scope.row.bmstatus==1">未开始</span>
                 <span v-else-if="scope.row.bmstatus==3">已结束</span>
                 <span v-else-if="scope.row.status==0">未上线</span>
             </el-tag>
         </template>
      </el-table-column>
      <el-table-column
      label="起止时间"
      width="180"
      >
       <template slot-scope="scope">
            <div>{{scope.row.starttime | timeToDate}}</div>
            <div>{{scope.row.endtime | timeToDate}}</div>
       </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
             <el-dropdown split-button type="primary" @click='handleEdit(scope.row.id)' @command='(command)=>handleItem(command,scope.row.id)'>
              编辑
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='online'>上线</el-dropdown-item>
                <el-dropdown-item command='offline'>下线</el-dropdown-item>
                <el-dropdown-item command='downloadjst' v-if="scope.row.isaddress==1">下载聚水谭上传表格</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" custom-class="commonDiag">
        <el-button type="primary" icon="el-icon-download" class="fr" @click="downloadTrainTable" size="small">下载名单</el-button>
        <el-table
               :data="memberlist"
               style="width: 100%">
               <el-table-column
                 prop="passcode"
                 label="学号">
               </el-table-column>
               <el-table-column
                 prop="name"
                 label="学员名称"
                >
               </el-table-column>
               <el-table-column
                 prop="mobile"
                 label="学员电话"
                >
               </el-table-column>
               <el-table-column
                 label="报名日期"
                >
                <template slot-scope="scope">
                    {{scope.row.createtime | timeToDate}}
                </template>
               </el-table-column>
        </el-table>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dialogFormVisible = false">取 消</el-button>
         <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
       </div>
     </el-dialog>

     <el-dialog
            title="赠送商品选择"
            :visible.sync="dialogVisible"
            custom-class="commonDiag"
            >
            <div style="margin-top: 15px;">
              <el-input placeholder="请输入赠品数量" v-model="goodsnums" class="input-with-select">
                <el-select v-model="goodsid" slot="prepend" placeholder="请选择" filterable >    
                  <el-option  v-for="item in goodslist" :label="item.giftname" :value="item.giftgoods" :key="item.giftgoods"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-plus" @click="addGift">添加</el-button>
              </el-input>
            </div>
             <el-table
              :data="giftlist"
              style="width: 100%">
              <el-table-column
                prop="name"
                label="名称"
                >
              </el-table-column>
              <el-table-column
                prop="nums"
                label="数量"
                >
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="{row}">
                  <el-button type="danger" size="small" @click="delGift(row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="height: 50px;margin-top:25px;">
              <el-button type="primary" class="fr" @click="doDownloadjst">确定下载</el-button>
            </div>
          </el-dialog>
   </div> 
</template>

<script>
import {downloadTrain,downloadJstTable} from '@/api'

export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },
        dialogFormVisible:false,
        dialogTitle:'',
        memberlist:[],
        curPeriodnum:'',


        dialogVisible:false,
        giftlist:[],
        goodslist:[],
        goodsmap:{},

        goodsid:'',
        goodsnums:'',
        curTrainid:''
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/school/getTrainList",{pageinfo:this.pageinfo,keywords:this.keywords}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.trainlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      downloadTrainTable(){
          downloadTrain("/download/mltb",{periodnum:this.curPeriodnum})  
      },
      showMemberlist(periodnum,title){
          this.curPeriodnum=periodnum
          this.dialogTitle="【"+title+"】报名清单"
          this.$post("/school/getMemberlist",{periodnum:periodnum}).then((data)=>{
               if(data.result.success){
                   this.memberlist=data.result.info
                   this.dialogFormVisible=true
               }else{
                   this.$message.error("获取信息有误");   
               }
          })
      },
      handleEdit(id){
          this.$router.push({name:'addtrain',query:{trainid:id}})
      },
      handleItem(command,trainid){
        switch(command){
          case 'online':
                this.alterStatus(1,trainid)
                break;
          case 'offline':
                this.alterStatus(0,trainid)
                break;    
          case  'downloadjst':
                this.giftlist=[]
                this.curTrainid=trainid
                this.$post("/goods/getGiftlist").then((data)=>{
                        if(data.result.success){
                            this.goodslist=data.result.info.list;
                            this.goodsmap=data.result.info.map;
                        }
                    })
                this.dialogVisible=true
                break;        
          default:
                this.$message.error("选项有误");      
        }
      },
      alterStatus(status,trainid){
        this.$post("/school/alterTrain",{status:status,trainid:trainid}).then((data)=>{
               if(data.result.success){
                  this.$message.success(data.result.info)
                  this.getList()
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      addGift(){
            if(this.goodsid==''){
            this.$message({type:"error",message:'请先选择赠送的商品'}); 
            return;
            }
            if(this.goodsnums==''||isNaN(this.goodsnums)||parseInt(this.goodsnums)<=0){
              this.$message({type:"error",message:'请输入赠品数量'}); 
              return;
            }
          
            let checkExist=this.giftlist.find(item=>item.id==this.goodsid)
            if(checkExist!=undefined){
              this.$message({type:"error",message:'已添加此赠品，如需修改数量，请删除原有赠品后重新添加'}); 
              return;
            }
            this.giftlist.push({id:this.goodsid,name:this.goodsmap[this.goodsid],nums:this.goodsnums})

            this.goodsid=''
            this.goodsnums=''
        },
        delGift(id){
            this.giftlist=this.giftlist.filter(item=>item.id!=id)
        },
        doDownloadjst(){
            if(this.giftlist.length<1){
              this.$message({type:"error",message:'请先添加赠送商品及数量'}); 
              return;
            }
            
            if(this.curTrainid==''){
              this.$message({type:"error",message:'内部参数有误'}); 
              return;
            }

            let params={id:this.curTrainid,goodsinfo:JSON.stringify(this.giftlist)}
            downloadJstTable("/download/DownloadJstTable",params)
        }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.blue{text-decoration: underline;cursor: pointer;}
</style>
